export default __webpack_public_path__ + "static/media/front.198f1ad7.png";